<template>
  <div class="login limiter">
    <div
      class="container-login100"
      v-bind:class="{ 'ui loading segment': processing }"
    >
      <div class="wrap-login100" ref="loading_target">
        <div
          class="login100-form-title"
          :style="
            'background-image: url(' + logo + '); height: 75px; padding: 50px'
          "
        >
          <span class="login100-form-title-1">&nbsp;</span>
        </div>
        <div class="login100-form validate-form" id="login_form">
          <div class="wrap-input100 validate-input m-b-18">
            <span class="label-input100">{{ username_field }}</span>
            <input
              class="input100"
              type="text"
              name="username"
              v-bind:placeholder="$t('username')"
              v-model="value.username"
            />
            <span class="focus-input100"></span>
          </div>
          <div class="wrap-input100 validate-input m-b-18">
            <span class="label-input100">{{ $t("password") }}</span>
            <input
              class="input100"
              type="password"
              name="password"
              v-bind:placeholder="$t('password')"
              v-model="value.password"
            />
            <span class="focus-input100"></span>
          </div>
          <div class="container-login100-form-btn" style="width:100%">
            <button
              class="login100-form-btn"
              type="submit"
              style="width: 100%;"
              v-on:click="$emit('do_auth')"
            >
              {{ $t("sign in") }}
            </button>
          </div>
          <language-login-selector
            style="max-width:unset !important; width: 100%; margin-top:20px"
          />
          <div class="eight wide column">
            <a href="#" @click="forgot_password">
              {{ $t("forgot my password") }}
            </a>
          </div>
        </div>
        <div
          class="ui error message"
          v-if="error"
          v-html="error"
          style="margin: 0px 80px 40px 80px; padding: 20px;"
        >
          <p></p>
        </div>
      </div>
      <template v-for="(mdl, index) in recovery_modals">
        <component
          :is="mdl"
          :key="index"
          v-on:destroy="destroy"
          v-on:succedded="destroy"
        ></component>
      </template>
    </div>
  </div>
</template>

<script>
import LanguageLoginSelector from "@/components/LanguageLoginSelector";
import PasswordRecoveryModal from "@/modules/student_portal/public/password_recovery/Index";

export default {
  name: "LoginSmartphoneView",
  components: { LanguageLoginSelector, PasswordRecoveryModal },
  data() {
    return {
      recovery_modals: [],
      // enterprise: "",
      // username: "",
      // password: "",
    };
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {};
      },
    },
    error: {
      type: String,
    },
    processing: {
      type: Boolean,
    },
    username_field: { type: String },
    logo: { type: String },
  },
  methods: {
    forgot_password() {
      this.recovery_modals.push(PasswordRecoveryModal);
    },
    destroy() {
      this.recovery_modals = [];
    },
  },
  computed: {},
  watch: {
    // enterprise() {
    //   this.$emit("input", {
    //     enterprise: this.enterprise,
    //     username: this.username,
    //     password: this.password,
    //   });
    // },
    // username() {
    //   this.$emit("input", {
    //     enterprise: this.enterprise,
    //     username: this.username,
    //     password: this.password,
    //   });
    // },
    // password() {
    //   this.$emit("input", {
    //     enterprise: this.enterprise,
    //     username: this.username,
    //     password: this.password,
    //   });
    // },
  },
};
</script>
